import type { ReactNode } from 'react'
import {
  BookOpen, Boxes, CalendarDays, ChartColumn, Database, FileText, Landmark, ListTodo, Mail, MonitorSmartphone, Receipt,
  Repeat, Search, Sparkles, Truck, Users, Wrench,
} from 'lucide-react'

/* ===========================================================================
 *  Een plaatje per onderwerp
 *
 *  Voor de stappen ("Zoekt in inkoopfacturen"), de bronnen onder een
 *  antwoord en de voorbeeldvragen. Op woorden in de naam en niet op een
 *  vaste lijst tools: komt er in de functie cowork een tool bij, dan krijgt
 *  hij hier vanzelf een passend plaatje als zijn naam op iets lijkt, en
 *  anders de database.
 * =========================================================================== */

const REGELS: [RegExp, (g: number) => ReactNode][] = [
  [/factu|inkoop|crediteur|debiteur|betal|openstaand/i, (g) => <Receipt size={g} />],
  [/exact|grootboek|balans|resultaat|winst|marge|boekhoud|administrat/i, (g) => <Landmark size={g} />],
  [/verkoop|omzet|kassa|transact|wasbeurt|cijfer/i, (g) => <ChartColumn size={g} />],
  [/relatie|klant|leverancier|contact/i, (g) => <Users size={g} />],
  [/terugkerend|herhaal/i, (g) => <Repeat size={g} />],
  [/\bit\b|it_ticket|ticket|laptop|printer|wifi/i, (g) => <MonitorSmartphone size={g} />],
  [/taak|taken|todo|actie/i, (g) => <ListTodo size={g} />],
  [/storing|werkbon|onderhoud|techniek|monteur/i, (g) => <Wrench size={g} />],
  [/rooster|dienst|planning|verlof|uren/i, (g) => <CalendarDays size={g} />],
  [/voorraad|artikel|product|truckshop|supply/i, (g) => <Boxes size={g} />],
  [/document|bestand|pdf|contract|handleiding/i, (g) => <FileText size={g} />],
  [/mail|inbox|bericht/i, (g) => <Mail size={g} />],
  [/vestiging|locatie|straat|baan/i, (g) => <Truck size={g} />],
  [/kennis|uitleg|academy|les/i, (g) => <BookOpen size={g} />],
  [/zoek/i, (g) => <Search size={g} />],
]

export function onderwerpIcoon(tekst: string, grootte = 15, standaard: 'database' | 'vonk' = 'database'): ReactNode {
  for (const [patroon, icoon] of REGELS) if (patroon.test(tekst)) return icoon(grootte)
  return standaard === 'vonk' ? <Sparkles size={grootte} /> : <Database size={grootte} />
}
